export const ALLOWED_HOUSE_COUNTRIES = ["DE", "BE", "NL", "FR"];

export const DATE_PICKER_DATE_FORMAT = "D/MM/YYYY";
